import { useState } from 'react';

export const useIsLoading = (_isLoading: boolean = false) => {
  const [isLoading, setIsLoading] = useState(_isLoading);
  return { isLoading, setIsLoading };
};